import { ProductStatus } from 'features/product'
import { PRODUCT_STATUSES } from 'features/product/types/productStatus'
import { authorizeGroupRole, User, UserWorkspaceRole } from 'features/user'
import { UserWorkspaceProductsSlice } from 'features/user/types/user'
import { Can } from '../Can'

export const product = (user: User, can: Can): void => {
  const { currentWorkspaceRole, role, workspaceProducts } = user

  const isInEmployeeGroup: boolean = authorizeGroupRole('employeesOnly', role)

  if (workspaceProducts === undefined || workspaceProducts.length === 0) {
    return
  }

  workspaceProducts.forEach(({ product, status }: UserWorkspaceProductsSlice): void => {
    const allowedStatuses: ProductStatus[] = prepareAllowedStatuses({ isInEmployeeGroup })
    const allowedWorkspaceRoles: UserWorkspaceRole[] = ['editor', 'owner']

    if (allowedStatuses.includes(status)) {
      can('access', `Product-${product}`)
    }

    if (
      isInEmployeeGroup ||
      (currentWorkspaceRole && allowedWorkspaceRoles.includes(currentWorkspaceRole))
    ) {
      can('update', `Product-${product}`)
    }
  })
}

const prepareAllowedStatuses = ({
  isInEmployeeGroup,
}: {
  isInEmployeeGroup: boolean
}): ProductStatus[] => {
  let allowed: ProductStatus[]

  if (isInEmployeeGroup) {
    allowed = PRODUCT_STATUSES.filter((ps: ProductStatus) => ps !== 'inactive')
  } else {
    allowed = ['trial', 'pro', 'proInSetup']
  }

  return allowed
}
